module.exports = __webpack_public_path__ + "img/en.e4f77113.svg";